







import { Component, Vue } from 'vue-property-decorator'
import GameList from './components/GameList.vue'
import GameStage from './components/GameStage.vue'

@Component({
  components: {
    GameList,
    GameStage,
  },
})
export default class App extends Vue {
  mode: Game | null = null

  changeGameMode(game: Game) {
    this.mode = game
  }

  closeGameMode(exit: GameExit) {
    this.mode = null
    switch (exit.reason) {
      case 'self-exit':
        this.$swal('누리놀배움을 그만두었습니다.')
        break
      case 'clear-exit':
        this.$swal('누리놀배움이 종료되었습니다.')
        break
    }
  }
}
